'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_model$package$KeywordId$() {
  $n_Lmealorama_model$package$KeywordId$ = this;
  $m_Lmealorama_model$package$KeywordId$();
}
export { $c_Lmealorama_model$package$KeywordId$ as $c_Lmealorama_model$package$KeywordId$ };
$p = $c_Lmealorama_model$package$KeywordId$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_model$package$KeywordId$;
/** @constructor */
function $h_Lmealorama_model$package$KeywordId$() {
}
export { $h_Lmealorama_model$package$KeywordId$ as $h_Lmealorama_model$package$KeywordId$ };
$h_Lmealorama_model$package$KeywordId$.prototype = $p;
var $d_Lmealorama_model$package$KeywordId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_model$package$KeywordId$, "mealorama.model$package$KeywordId$", ({
  KR: 1
}));
export { $d_Lmealorama_model$package$KeywordId$ as $d_Lmealorama_model$package$KeywordId$ };
var $n_Lmealorama_model$package$KeywordId$;
function $m_Lmealorama_model$package$KeywordId$() {
  if ((!$n_Lmealorama_model$package$KeywordId$)) {
    $n_Lmealorama_model$package$KeywordId$ = new $c_Lmealorama_model$package$KeywordId$();
  }
  return $n_Lmealorama_model$package$KeywordId$;
}
export { $m_Lmealorama_model$package$KeywordId$ as $m_Lmealorama_model$package$KeywordId$ };
//# sourceMappingURL=mealorama.model$package$-Keyword-Id$.js.map
